// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loader-wrapper--vSH_R6yyGxo0TGrZmnLV"};